<template>
  <component
    :is="tag"
    v-b-tooltip.hover
    :title="tooltip"
    class="datatable-user-text"
  >{{ display }}</component>
</template>

<script>
import {
  formatDatatableUserText,
  getDatatableUserTextOptions,
} from '@/libs/datatableUserText'

export default {
  name: 'DatatableUserText',
  props: {
    value: {
      default: null,
    },
    field: {
      type: String,
      default: null,
    },
    tag: {
      type: String,
      default: 'span',
    },
    maxLength: {
      type: Number,
      default: null,
    },
    noSpaceMaxLength: {
      type: Number,
      default: null,
    },
  },
  computed: {
    formatted() {
      const overrides = {}
      if (this.maxLength != null) {
        overrides.maxLength = this.maxLength
      }
      if (this.noSpaceMaxLength != null) {
        overrides.noSpaceMaxLength = this.noSpaceMaxLength
      }

      return formatDatatableUserText(this.value, getDatatableUserTextOptions(this.field, overrides))
    },
    display() {
      return this.formatted.display
    },
    tooltip() {
      return this.formatted.tooltip
    },
  },
}
</script>

<style>
.datatable-user-text {
  overflow-wrap: anywhere;
  word-break: break-word;
}
</style>
